import { CheckOutlined } from "@ant-design/icons";
import { ReactElement } from "react";
import { DocumentItemUI } from "../../../../../Ui/DocumentItems/DocumentItemUI/DocumentItemUI";

import classes from "./SignDocItem.module.css";
import { ISignDocItemProps } from "../../../../../../interfaces/props/ISignDocItemProps";

export function SignDocItem(props: ISignDocItemProps): ReactElement {
  const { title, subtitle, className, ...restProps } = props;
  const concatContainerClassName = `${className ? className : ""} ${
    classes.signDocItem
  }`;

  return (
    <div {...restProps} className={concatContainerClassName}>
      <CheckOutlined className={classes.checkIcon} />
      <DocumentItemUI
        className={classes.documentInfo}
        title={title}
        subtitle={subtitle}
      />
    </div>
  );
}
